import Styled from "styled-components";

export const Container = Styled.div`
  padding: 2rem 0;
  margin: auto;

  ${(props) => props.theme.breakpoints.up("medium")} {
    padding: 4.6875rem 0;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    padding: 5.625rem 0;
  }
`;

export const Content = Styled.div`
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 3rem);
    gap: 2rem;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    max-width: calc(100% - 10rem);
  }
`;

export const HeadlineContainer = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  gap: 1rem;
  margin-bottom: 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 2rem;
    margin-bottom: 1.75rem;
  }
`;

export const TagContainer = Styled.div`
  border-radius: 1.75rem;
  box-shadow: 0px 2px 8px 0px rgba(3, 3, 3, 0.16);
  padding: 1px;
  background: linear-gradient(99.54deg, #545454 0%, #212121 100%);
`;

export const TagContent = Styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 1.75rem;
  background: linear-gradient(91deg, rgba(46, 46, 46, 0.20) 0%, rgba(127, 127, 127, 0.20) 100%), black;
`;

export const QAContainer = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  gap: 1rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 1.5rem;
  }
`;

export const FaqItem = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.5rem;

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 1rem;
  }
`;

export const FaqItemQuestion = Styled.div`
`;

export const FaqItemAnswer = Styled.div`
`;

export const Link = Styled.a`
  text-decoration: none;
`;
